(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('GraphQLService', GraphQLService);

    GraphQLService.$inject = ['$http', '$q'];

    function GraphQLService($http, $q) {
        var service = {
            query: query,
            publicQuery: publicQuery,
            mutate: mutate
        };

        return service;

        /**
         * Execute a GraphQL query
         * @param {string} queryString - The GraphQL query string
         * @param {object} variables - Variables for the query
         * @returns {promise} Promise with the query result
         */
        function query(queryString, variables) {
            return executeQuery('/api/graphql', queryString, variables);
        }

        /**
         * Execute a public GraphQL query against the limited public schema
         * @param {string} queryString - The GraphQL query string
         * @param {object} variables - Variables for the query
         * @returns {promise} Promise with the query result
         */
        function publicQuery(queryString, variables) {
            return executeQuery('/api/public/graphql', queryString, variables);
        }

        /**
         * Execute a GraphQL mutation
         * @param {string} mutationString - The GraphQL mutation string
         * @param {object} variables - Variables for the mutation
         * @returns {promise} Promise with the mutation result
         */
        function mutate(mutationString, variables) {
            return query(mutationString, variables);
        }

        function executeQuery(endpoint, queryString, variables) {
            return $http.post(endpoint, {
                query: queryString,
                variables: variables || {}
            }).then(function(response) {
                if (response.data.errors) {
                    console.error('GraphQL errors:', response.data.errors);
                    return $q.reject(response.data.errors);
                }
                return response.data.data;
            }).catch(function(error) {
                console.error('GraphQL request failed:', error);
                return $q.reject(error);
            });
        }
    }
})();
